import Vue from 'vue'
import VueRouter from 'vue-router'
import newOrder from './components/newOrder.vue'
import pendingAnswerOrder from './components/pendingAnswerOrder.vue'
import processedOrder from './components/processedOrder.vue'
import canceledOrder from './components/canceledOrder.vue'
import damageOrder from './components/damageOrder/damageOrder.vue'
import returnOrder from './components/returnOrder/returnOrder.vue'
import approvedOrder from './components/approvedOrder.vue'
import refundedOrder from './components/refundedOrder.vue'
import purchasedOrder from './components/purchasedOrder.vue'
import warehouseDeliveredOrder from './components/warehouseDeliveredOrder.vue'
import intShipmentOrder from './components/intShipmentOrder.vue'
import pendingToShipmentOrder from './components/pendingToShipment/pendingToShipment.vue'
import branchDeliveredOrder from './components/branchDeliveredOrder.vue'
import pendingToBranchOrder from './components/pendingToBranchOrder.vue'
import user from './components/user/user.vue'
import userProfile from './components/user/userProfile.vue'
import regularUser from './components/user/regularUser.vue'
import userDeliveredOrder from './components/userDeliveredOrder.vue'
import adminArchivedOrder from './components/adminArchivedOrder.vue'
import adminDashboard from './components/adminDashboard.vue'
import credit from './components/user/user_credit/credit.vue'
import creditLogTransaction from './components/logs/creditLogTransaction.vue'
import creditLogAction from './components/logs/creditLogAction.vue'
import coupon from './components/coupons/coupon.vue'
import home from './components/home.vue'
import myOrder from './components/customer/myOrders.vue'
import myOrderCases from './components/customer/myOrderCases.vue'
import myExportOrders from './components/customer/exportOrder/myExportOrders.vue'
import addExportOrder from './components/customer/exportOrder/addExportOrder.vue'
import myExportOrderDetail from './components/customer/exportOrder/myExportOrderDetail.vue'
import archivedOrder from './components/customer/archivedOrder.vue'
import invoice from './components/customer/invoices.vue'
import orderDetail from './components/customer/orderDetail.vue'
import makeNewOrder from './components/customer/makeNewOrder.vue'
import addNewShipOnly from './components/customer/addNewShipOnly.vue'
import newShipOnly from './components/customer/newShipOnly.vue'
import chargeBalance from './components/customer/chargeBalance.vue'
import orderLog from './components/orderLog.vue'
import activityLog from './components/activityLog.vue'
import secret from './components/secret.vue'
import customerCreditInvoice from './components/customer/customerCreditInvoice.vue'
import customerOrderInvoice from './components/customer/customerOrderInvoices.vue'
import payWithFib from './components/customer/payWithFib.vue'
import payWithFastPay from './components/customer/payWithFastPay.vue'
import payWithQi from './components/customer/payWithQi.vue'
import payWithZainCash from './components/customer/payWithZainCash.vue'
import checkRate from './components/customer/checkRate.vue'
import exportableOrder from './components/exportableOrder.vue'
import allOrder from './components/allOrder.vue'
import warehouseDatePassed from './components/warehouseDatePassed.vue'
import customerPrices from './components/customerPrices'
import kreenexFeePrices from './components/kreenexFeePrices'
import shippingPrices from './components/shippingPrices'
import banks from './components/bank/banks'
import BankTransactions from './components/bankTransactions/bankTransactions.vue'
import ExchangeRate from './components/exchangeRate/exchangeRate'
import StatisticsDashboard from './components/statisticsDashboard.vue'
import DeliveredReport from './components/report/deliveredReport'
import OrdersReport from './components/report/ordersReport'
import CustomersReport from './components/report/customersReport'
import InvoicesReport from './components/report/invoicesReport'
import SalesReport from './components/report/salesReport'
import BuysReport from './components/report/buysReport'
import GainedReport from './components/report/gainedReport'
import ExpensesReport from './components/report/expensesReport'
import RevenueReport from './components/report/revenueReport'
import OrderCostsReport from './components/report/orderCostsReport'
import ProfitReport from './components/report/profitReport'
import OrderStatusReport from './components/report/orderStatusReport'
import CustomerInvoicesReport from './components/report/customerInvoicesReport'
import DailyRevenueReport from './components/report/dailyRevenueReport'
import UnpaidReceivedInvoices from './components/report/unpaidReceivedInvoices'
import UnpaidArrivedInvoices from './components/report/unpaidArrivedInvoices'
import DeliveryReport from './components/report/deliveryReport'
import loanedCustomers from './components/user/loanedCustomers.vue'
import ShipOnly from './components/shipOnly.vue'
import Supplier from './components/supplier/suppliers.vue'
import ExpenseType from './components/expenseType/expenseTypes.vue'
import Expense from './components/expense/expenses.vue'
import OrderInvoice from './components/orderInvoice/orderInvoices.vue'
import CapitalPage from './components/capital/CapitalPage.vue'
import Profit from './components/profit.vue'
import MoneyTransfer from './components/moneyTransfer/moneyTransfer.vue'
import Role from './components/roles/roles.vue'
import Settings from './components/settings/settings.vue'
// import Branch from './components/branch/branches.vue'
import partialRefundInvoices from './components/partialRefundInvoices.vue'
import customerPartialRefundInvoices from './components/customer/customerPartialRefundInvoices.vue'
import DeliveryInvoice from './components/deliveryInvoice/deliveryInvoices.vue'
import PurchaseHistory from './components/purchaseHistory.vue'
import City from './components/city/city.vue'
import Governorate from './components/governorate/governorate.vue'
import cancellationReason from './components/CancellationReason/reason.vue'
import aboutAppMobile from './components/about/about.vue'
import helpCenterView from './components/helpCenter/helpCenter.vue'
import NotFoundOrder from './components/notFoundOrder/notFoundOrders.vue'
import OrderCases from './components/orderCase/orderCases.vue'
import OrderCaseUsers from './components/orderCase/orderCaseUsers.vue'
import customerRegistration from './components/customerRegistration.vue'
import homeSlider from './components/homeSlider/homeSlider.vue'
import homeBanner from './components/homeBanner/homeBanner.vue'
import popularWebsite from './components/popularWebsite/popularWebsite.vue'
import globalWebsiteGroup from './components/globalWebsite/globalWebsiteGroup.vue'
import globalWebsite from './components/globalWebsite/globalWebsite.vue'
import orderDelivery from './components/orderDelivery/orderDeliveries.vue'
import sendNotification from './components/notification/sendNotification.vue'
import pendingExportOrder from './components/exportOrder/pendingExportOrder.vue'
import processedExportOrder from './components/exportOrder/processedExportOrder.vue'
import refundedExportOrder from './components/exportOrder/refundedExportOrder.vue'
import canceledExportOrder from './components/exportOrder/canceledExportOrder.vue'
import approvedExportOrder from './components/exportOrder/approvedExportOrder.vue'
import sentExportOrder from './components/exportOrder/sentExportOrder.vue'
import receivedExportOrder from './components/exportOrder/receivedExportOrder.vue'
import exportHistory from './components/exportOrder/exportHistory.vue'
import currencyRate from './components/currencyRate/currencyRate.vue'
import CustomerVerification from './components/customerVerification/CustomerVerification.vue'
import PrivacyAndPolicy from './PrivacyAndPolicy.vue'
import warehouse from './components/warehouse/warehouse.vue'
import forceUpdate from './components/forceUpdate/forceUpdate.vue'
import linkRules from './components/linkRules/linkRules.vue'
import ourAddress from './components/ourAddress/ourAddress.vue'
import subscription from './components/subscription/subscription.vue'
import customerSubscription from './components/user_subscription/userSubscription.vue'
import subscriptionPricing from './components/subscription_pricing/subscriptionPricing.vue'
import OrderTypes from './components/orderType/orderTypes.vue'
import OrderStatusSettings from './components/orderStatus/orderStatusSettings.vue'
import PrintLogs from './components/PrintLogs.vue'
import driverDeliver from './components/driverDeliver.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/customer-registration',
      component: customerRegistration
    },
    {
      path: '/customer-verification',
      component: CustomerVerification
    },
    {
      path: '/privacy-and-policy',
      component: PrivacyAndPolicy
    },
    // {
    //   path: '/branch',
    //   component: Branch
    // },
    {
      path: '/force-update',
      component: forceUpdate
    },
    {
      path: '/link-rules',
      component: linkRules
    },
    {
      path: '/our-address',
      component: ourAddress
    },
    {
      path: '/warehouse',
      component: warehouse
    },
    {
      path: '/send-notification',
      component: sendNotification
    },
    {
      path: '/roles',
      component: Role
    },
    {
      path: '/put_money',
      redirect: '/capital'
    },
    {
      path: '/partial-refund',
      component: partialRefundInvoices
    },
    {
      path: '/not-found-orders',
      component: NotFoundOrder
    },
    {
      path: '/order-cases',
      component: OrderCases
    },
    {
      path: '/order-case-progress',
      component: OrderCaseUsers
    },
    {
      path: '/customer-partial-refund',
      component: customerPartialRefundInvoices
    },
    {
      path: '/delivery-invoice',
      component: DeliveryInvoice
    },
    {
      path: '/purchase-history',
      component: PurchaseHistory
    },
    {
      path: '/export-order/pending',
      component: pendingExportOrder
    },
    {
      path: '/export-order/processed',
      component: processedExportOrder
    },
    {
      path: '/export-order/canceled',
      component: canceledExportOrder
    },
    {
      path: '/export-order/approved',
      component: approvedExportOrder
    },
    {
      path: '/export-order/sent',
      component: sentExportOrder
    },
    {
      path: '/export-order/received',
      component: receivedExportOrder
    },
    {
      path: '/export-order/export-history',
      component: exportHistory
    },
    {
      path: '/export-order/refunded',
      component: refundedExportOrder
    },
    {
      path: '/profit',
      component: Profit
    },
    {
      path: '/money-transfer',
      component: MoneyTransfer
    },
    {
      path: '/capital',
      component: CapitalPage
    },
    {
      path: '/settings',
      component: Settings
    },
    {
      path: '/expense-type',
      component: ExpenseType
    },
    {
      path: '/expense',
      component: Expense
    },
    {
      path: '/order_invoice',
      component: OrderInvoice
    },
    {
      path: '/order-types',
      component: OrderTypes
    },
    {
      path: '/order-status-settings',
      component: OrderStatusSettings
    },
    {
      path: '/supplier',
      component: Supplier
    },
    {
      path: '/ship-only',
      component: ShipOnly
    },
    {
      path: '/loan-customers',
      component: loanedCustomers
    },
    {
      path: '/delivered-report',
      component: DeliveredReport
    },
    {
      path: '/report/orders',
      component: OrdersReport
    },
    {
      path: '/report/customers',
      component: CustomersReport
    },
    {
      path: '/report/invoices',
      component: InvoicesReport
    },
    {
      path: '/report/sales',
      component: SalesReport
    },
    {
      path: '/report/buys',
      component: BuysReport
    },
    {
      path: '/report/gained',
      component: GainedReport
    },
    {
      path: '/report/expenses',
      component: ExpensesReport
    },
    {
      path: '/report/revenue',
      component: RevenueReport
    },
    {
      path: '/report/order-costs',
      component: OrderCostsReport
    },
    {
      path: '/report/profit',
      component: ProfitReport
    },
    {
      path: '/report/order-status',
      component: OrderStatusReport
    },
    {
      path: '/report/customer-invoices',
      component: CustomerInvoicesReport
    },
    {
      path: '/report/daily-revenue',
      component: DailyRevenueReport
    },
    {
      path: '/report/unpaid-received',
      component: UnpaidReceivedInvoices
    },
    {
      path: '/report/unpaid-arrived',
      component: UnpaidArrivedInvoices
    },
    {
      path: '/report/delivery',
      component: DeliveryReport
    },
    {
      path: '/exchange-rate',
      component: ExchangeRate
    },
    {
      path: '/banks',
      component: banks
    },
    {
      path: '/bank-transactions',
      component: BankTransactions
    },
    {
      path: '/currency-rate',
      component: currencyRate
    },
    {
      path: '/shipping-prices',
      component: shippingPrices
    },
    {
      path: '/kreenex-fee-prices',
      component: kreenexFeePrices
    },
    {
      path: '/customer-prices',
      component: customerPrices
    },
    {
      path: '/new-order',
      component: newOrder
    },
    {
      path: '/pending-answer-order',
      component: pendingAnswerOrder
    },
    {
      path: '/processed_order',
      component: processedOrder
    },
    {
      path: '/canceled_order',
      component: canceledOrder
    },
    {
      path: '/damage_order',
      component: damageOrder
    },
    {
      path: '/return_order',
      component: returnOrder
    },
    {
      path: '/approved_order',
      component: approvedOrder
    },
    {
      path: '/refunded_order',
      component: refundedOrder
    },
    {
      path: '/purchased_order',
      component: purchasedOrder
    },
    {
      path: '/warehouse_delivered_order',
      component: warehouseDeliveredOrder
    },
    {
      path: '/pending_to_shipment_order',
      component: pendingToShipmentOrder
    },
    {
      path: '/int_shipment_order',
      component: intShipmentOrder
    },
    {
      path: '/pending_to_branch_order',
      component: pendingToBranchOrder
    },
    {
      path: '/branch_delivery_order',
      component: branchDeliveredOrder
    },
    {
      path: '/',
      component: home
    },
    {
      path: '/dashboard',
      component: adminDashboard
    },
    {
      path: '/subscription',
      component: subscription
    },
    {
      path: '/customer-subscription',
      component: customerSubscription
    },
    {
      path: '/subscription-pricing',
      component: subscriptionPricing
    },
    {
      path: '/users',
      component: user
    },
    {
      path: '/my-profile',
      component: userProfile
    },
    {
      path: '/regular-user',
      component: regularUser
    },
    {
      path: '/user-delivered-order',
      component: userDeliveredOrder
    },
    {
      path: '/admin-archived-order',
      component: adminArchivedOrder
    },
    {
      path: '/credit',
      component: credit
    },
    {
      path: '/credit-log-transaction',
      component: creditLogTransaction
    },
    {
      path: '/credit-log-action',
      component: creditLogAction
    },
    {
      path: '/coupon',
      component: coupon
    },
    {
      path: '/my-order',
      component: myOrder
    },
    {
      path: '/my-order-cases',
      component: myOrderCases
    },
    {
      path: '/my-export-order',
      component: myExportOrders
    },
    {
      path: '/add-new-export-order',
      component: addExportOrder
    },
    {
      path: '/my-export-order-detail/:id',
      component: myExportOrderDetail
    },
    {
      path: '/archived-order',
      component: archivedOrder
    },
    {
      path: '/customer-invoice',
      component: invoice
    },
    {
      path: '/order-detail',
      component: orderDetail
    },
    {
      path: '/make-new-order/:order_id?',
      component: makeNewOrder
    },
    {
      path: '/make-new-ship-only',
      component: addNewShipOnly
    },
    {
      path: '/new-ship-only',
      component: newShipOnly
    },
    {
      path: '/shipzone-admin',
      component: home
    },
    {
      path: '/order-log',
      component: orderLog
    },
    {
      path: '/activity-log',
      component: activityLog
    },
    {
      path: '/secret',
      component: secret
    },
    {
      path: '/customer-credit-invoice',
      component: customerCreditInvoice
    },
    {
      path: '/customer-order-invoice',
      component: customerOrderInvoice
    },
    {
      path: '/charge-balance',
      component: chargeBalance
    },
    {
      path: '/pay-with-fib',
      component: payWithFib
    },
    {
      path: '/pay-with-fastpay',
      component: payWithFastPay
    },
    {
      path: '/pay-with-qi',
      component: payWithQi
    },
    {
      path: '/pay-with-zaincash',
      component: payWithZainCash
    },
    {
      path: '/check-rate',
      component: checkRate
    },
    {
      path: '/exportable-order',
      component: exportableOrder
    },
    {
      path: '/all-order',
      component: allOrder
    },
    {
      path: '/warehouse-date-passed',
      component: warehouseDatePassed
    },
    {
      path: '/city',
      component: City
    },
    {
      path: '/governorate',
      component: Governorate
    },
    {
      path: '/reason',
      component: cancellationReason
    },
    {
      path: '/about',
      component: aboutAppMobile
    },
    {
      path: '/help-center',
      component: helpCenterView
    },
    {
      path: '/home-banner',
      component: homeBanner
    },
    {
      path: '/home-slider',
      component: homeSlider
    },
    {
      path: '/popular-website',
      component: popularWebsite
    },
    {
      path: '/global-website-group',
      component: globalWebsiteGroup
    },
    {
      path: '/global-website-group/:id/sites',
      name: 'global-website-group.sites',
      component: globalWebsite
    },
    {
      path: '/order-delivery',
      component: orderDelivery
    },
    {
      path: '/statistics',
      component: StatisticsDashboard
    },
    {
      path: '/print-logs',
      component: PrintLogs
    },
    {
      path: '/driver-deliver/:order_id',
      component: driverDeliver
    },
    {
      path: '*',
      component: {
        template: `<div width="100%" class="text-center">
                                    <img src="../assets/images/not_found.jpg" alt="">
                                </div>`
      }
    }
  ]
})
export default router



// WEBPACK FOOTER //
// ./src/routes.js